<template>
  <modal
    name="send-permit-ivitations"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="550"
    height="auto"
    @before-open="resetData"
  >
    <div class="modalWrapper">
      <div class="content__box">
        <div class="content__box__header">
          <p class="text-white txt--ss opacity--50">Permit Invitations</p>
        </div>
        <div class="content__divider"></div>
        <div class="content__box__body">
          <div class="form-group">
            <label class="txt--ss txt--off-white mb-2"> Group name </label>
            <input
              type="text"
              class="textInputField"
              placeholder="Enter a group name"
              v-model.trim="groupName"
            />
          </div>
          <div class="form-group">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                flex-wrap
              "
            >
              <div class="mb-2">
                <label
                  :class="[
                    'txt--ss cursor-pointer mb-0',
                    emailUploadProcess === 'email'
                      ? 'txt--primary'
                      : 'txt--off-white',
                  ]"
                  @click="emailUploadProcess = 'email'"
                >
                  Email Address(s)
                </label>

                <p
                  class="txt--xs txt--off-white"
                  v-if="emailUploadProcess === 'email'"
                >
                  separate emails by pressing enter<!-- a space or comma -->
                </p>
              </div>
              <p
                :class="[
                  'txt--ss  cursor-pointer mb-2',
                  emailUploadProcess === 'csv'
                    ? 'txt--primary'
                    : 'txt--off-white',
                ]"
                @click="emailUploadProcess = 'csv'"
              >
                Upload CSV
              </p>
            </div>

            <div class="" v-if="emailUploadProcess === 'email'">
              <!--  <input
                type="text"
                placeholder="Enter email address(s)"
                class="textInputField"
                v-model="emailInvitation"
              /> -->
              <vue-tags-input
                v-model="emailtag"
                :tags="emailtags"
                @tags-changed="(newTags) => (emailtags = newTags)"
                :separators="[' ']"
                placeholder="Enter email address(s)"
              />
            </div>
            <div
              class="monthlySubsForm py-2"
              v-if="emailUploadProcess === 'csv'"
            >
              <div class="monthlySubsForm__upload mb-1">
                <ButtonWithSpinner
                  class="button button--primary button--sm mr-3 mb-2"
                  :disabled="buttonCSV.disabled"
                  :loading="buttonCSV.loading"
                  :success="buttonCSV.success"
                  @click="$refs.csvFileInput.click()"
                >
                  Upload
                </ButtonWithSpinner>

                <label
                  class="monthlySubsForm__upload__button"
                  style="display: none"
                  ><input
                    type="file"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    ref="csvFileInput"
                    @change="uploadCSV"
                  />
                  Upload
                </label>
              </div>
              <p class="txt--xs txt--off-white text-center">
                (Upload CSV or Excel only)
              </p>

              <div class="file-preview-name my-2" v-if="csv_file != ''">
                <span class="name">{{ csv_name }}</span>
                <span class="remove" @click="resetCSV()"
                  ><i class="fas fa-times"></i
                ></span>
              </div>

              <a
                href="Sample/SampleInvitation.csv"
                download=""
                class="
                  txt--xs txt--off-white
                  text-center
                  d-flex
                  justify-content-center
                  mt-2
                "
                >Download Sample CSV
                <span class="ml-2"
                  ><i class="fas fa-cloud-download-alt"></i></span
              ></a>
            </div>
          </div>
         <!--  <div class="form-group">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                flex-wrap
                mb-2
              "
            >
              <p class="txt--xs txt--off-white">Properties (required)</p>

              <app-toggle
                label="All properties"
                :checked="all_property"
                @update:checked="checkAllProperty($event)"
              >
              </app-toggle>
            </div>
            <multi-list-select
              v-if="!all_property"
              :list="propertyListsMulti"
              :selected-items="choosenPropertyIdArr"
              option-value="space_id"
              option-text="property_name"
              placeholder="Select properties"
              class="custom-vue-select"
              @select="onSelect"
            ></multi-list-select>
          </div> -->
          <div class="form-group">
            <label class="txt--ss txt--off-white mb-2">
              Permit (required)
            </label>
            <multiselect
              class="multi-select-input"
              v-model="value"
              :options="options"
              :multiple="true"
              :close-on-select="false"
              group-values="permits"
              group-label="poperty"
              :group-select="true"
              placeholder="Select permit"
              track-by="id"
              label="name"
            >
              <span slot="noResult">Oops! No permit found</span>
              <template slot="tag" slot-scope="{ option, remove }"
                ><span class="multiselect__tag">
                  <span>{{ option.poperty_name + " - " + option.name }}</span>
                  <i
                    aria-hidden="true"
                    tabindex="1"
                    class="multiselect__tag-icon"
                    @click="remove(option)"
                  ></i> </span
              ></template>
            </multiselect>
          </div>
          <div class="form-group">
            <label class="txt--ss txt--off-white mb-2">
              Number of property choices (optional)
            </label>
            <input
              type="number"
              class="textInputField"
              placeholder="Enter # of property choices an invitee can select"
              v-model.number="choicesProperty"
            />
          </div>

          <div class="form-group">
            <div class="form-row">
              <div class="col-sm-6">
                <label class="txt--ss txt--off-white mb-2">
                  Invitation start date
                </label>
                <datetime
                  title="Start Date"
                  input-id="start_date"
                  class="dateTime__picker"
                  format="MM-dd-yyyy HH:mm:ss"
                  :input-class="['textInputField']"
                  value-zone="local"
                  type="datetime"
                  :clear-button="true"
                  placeholder="MM/DD/YYYY HH:mm:ss"
                  :min-datetime="min_date"
                  v-model="invitationStartDate"
                ></datetime>
              </div>
              <div class="col-sm-6">
                <label class="txt--ss txt--off-white mb-2">
                  Invitation expiry date (optional)
                </label>
                <datetime
                  title="Expiration Date"
                  input-id="start_date"
                  class="dateTime__picker"
                  format="MM-dd-yyyy HH:mm:ss"
                  :input-class="['textInputField']"
                  value-zone="local"
                  type="datetime"
                  :clear-button="true"
                  placeholder="MM/DD/YYYY HH:mm:ss"
                  :min-datetime="invitationStartDate"
                  v-model="invitationExpirationDate"
                ></datetime>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-center flex-wrap pt-4">
            <ButtonWithSpinner
              class="button button--primary button--sm mr-3 mb-2"
              @click="sendInvitation()"
              :disabled="button.disabled"
              :loading="button.loading"
              :success="button.success"
            >
              Send</ButtonWithSpinner
            >
            <button
              type="button"
              class="button button--outline button--sm mb-2"
              @click="closeModal()"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>

<script>
import ButtonWithSpinner from "@/components/Button";
import VueTagsInput from "@johmun/vue-tags-input";
//import Toggle from "@/components/toggle";
//import { MultiListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

export default {
  name: "Send-Permit-Invitations",
  components: {
    //AppToggle: Toggle,
    //MultiListSelect,
    datetime: Datetime,
    ButtonWithSpinner,
    VueTagsInput,
  },
  data() {
    return {
      emailUploadProcess: "email",
      propertyLists: [],
      choosenPropertyId: null,
      choosenPropertyIdArr: [],
      all_property: false,
      groupName: "",
      emailInvitation: "",
      emailInvitationArr: [],
      choicesProperty: "",
      invitationExpirationDate: null,
      invitationStartDate: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
      min_date: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
      csv_name: "",
      csv_file: "",
      options: [],
      value: [],
      emailtag: "",
      emailtags: [],

      button: {
        loading: false,
        success: false,
        disabled: false,
      },
      buttonCSV: {
        loading: false,
        success: false,
        disabled: false,
      },
      propertyListsMulti: [
        {
          property_name: "",
          space_id: "",
        },
      ],
      permit_list:[],
      selected_permit_ids :[],
    };
  },
  computed: {
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.emailtag.toLowerCase()) !== -1;
      });
    },
  },
  created() {
    this.resetData();
    //this.getAllproperty();
    this.getAllpermits();
  },
  methods: {
    resetData() {
      this.emailUploadProcess = "email";
      this.groupName = "";
      this.emailInvitation = "";
      this.choicesProperty = "";
      this.choosenPropertyId = null;
      this.min_date = this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ");
      this.invitationStartDate = this.$moment().format(
        "YYYY-MM-DDTHH:mm:ss.sssZ"
      );
      this.invitationExpirationDate = null;
      this.all_property = false;
      this.button.disabled = false;
      this.button.loading = false;
      this.button.success = false;
      this.buttonCSV.disabled = false;
      this.buttonCSV.loading = false;
      this.buttonCSV.success = false;
      this.choosenPropertyIdArr = [];
      this.emailtags = [];
      this.csv_file = "";
      this.csv_name = "";
      this.selected_permit_ids = [];
      this.value = [];
      //this.options = [];
      //this.permit_list = [];
      //this.propertyListsMulti = [];
    },
    resetCSV() {
      let input = this.$refs.csvFileInput;
      input.type = "text";
      input.type = "file";
      this.csv_file = "";
      this.csv_name = "";
      this.buttonCSV.disabled = false;
      this.buttonCSV.loading = false;
      this.buttonCSV.success = false;
    },
    onSelect(items, lastSelectItem) {
      this.choosenPropertyIdArr = items;
      this.choosenPropertyId = lastSelectItem;
    },
    closeModal() {
      this.resetData();
      this.$modal.hide("send-permit-ivitations");
    },
    getAllpermits() {
      this.axios
        .post(window.hostname + "/api/auth/permit/list", {
          device_type: 1,
          commercial: 1,
          all:1,
        })
        .then((res) => {
          if (res.data.status) {
             this.options=[];
            this.permit_list = res.data.data.permit_list;
            
            this.permit_list.forEach((item, index)=>{
              //console.log(item);
             

             /*  if(this.options.some(option => option.poperty == item.property_name)) {
                console.log("item.property_name>>>>>>"+item.property_name);
              } */
              var index_item = this.options.map(function(o) { return o.poperty; }).indexOf(item.property_name);
              if (index_item>-1){
                //console.log(">>>>>>"+index_item);
                 this.options[index_item].permits.push(
                      {      
                          id : item.permit_id, 
                          name : item.permit_name, 
                          poperty_name : item.property_name,  
                          property_id :  item.property_id,               
                      }
                 );
              }
              else{

                  this.options.push({
                      poperty: item.property_name,
                      permits: [
                        {
                          id : item.permit_id, 
                          name : item.permit_name, 
                          poperty_name : item.property_name,
                          property_id :  item.property_id,
                        },
                      ],
                    
                    });
              }
            });
           
          } else {
            //this.propertyListsMulti = [];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
   /*  getAllproperty() {
      this.axios
        .post(window.hostname + "/api/auth/all-space", {
          device_type: 1,
          limit: 100,
          page: 1,
          search_param: "",
          space_type: 1,
          status: 4,
        })
        .then((res) => {
          if (res.data.status) {
            //this.propertyLists = res.data.data.all_space;

            // this.propertyListsMulti =  res.data.data.all_space;
            this.propertyListsMulti = res.data.data.all_space.map(
              ({ space_id, property_name }) => ({ space_id, property_name })
            );
          } else {
            this.propertyListsMulti = [];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkAllProperty(e) {
      this.all_property = e;
      this.choosenPropertyIdArr = [];
    }, */
    uploadCSV(event) {
      this.buttonCSV.disabled = true;
      this.buttonCSV.loading = true;
      this.buttonCSV.success = false;

      let input = this.$refs.csvFileInput;

      let mimes = [
        "text/comma-separated-values",
        "text/csv",
        "application/csv",
        "application/excel",
        "application/vnd.ms-excel",
        "application/vnd.msexcel",
        "text/anytext",
        "csv",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "",
      ];

      if (
        event.target.files.length > 0 &&
        mimes.indexOf(event.target.files[0].type) != -1
      ) {
        if (event.target.files[0].size <= 5 * 1024 * 1024) {
          this.csv_name = event.target.files[0].name;
          this.csv_name = this.csv_name.split(".csv")[0];

          this.csv_file = event.target.files[0];

          this.buttonCSV.disabled = false;
          this.buttonCSV.loading = false;
          this.buttonCSV.success = true;

          //this.formData.append("csv", event.target.files[0]);
        } else {
          this.buttonCSV.disabled = false;
          this.buttonCSV.loading = false;
          this.buttonCSV.success = false;

          this.$toasted.show("Please upload a valid CSV file!", {
            icon: "times-circle",
            className: "error-class",
          });
          this.csv_name = "";
          input.type = "text";
          input.type = "file";
        }
      } else {
        this.$toasted.show("Please upload a valid CSV file!", {
          icon: "times-circle",
          className: "error-class",
        });
        this.csv_name = "";
        input.type = "text";
        input.type = "file";
      }
    },
    sendInvitation() {

      this.emailInvitation = this.emailtags
        .filter((val) => val.text)
        .map(({ text }) => text);

      if (this.groupName == "") {
        this.$toasted.show("Please provide a group name!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }

      if (this.emailInvitation == "" && this.csv_file == "") {
        this.$toasted.show("Please add emails or upload csv!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }

      if (this.emailInvitation != "" && this.csv_file == "") {
        //var nameArr = this.emailInvitation.split(/[ ,]+/);
        this.emailInvitationArr = this.emailInvitation.toString().split(/[,]+/);

        for (var j = 0; j < this.emailInvitationArr.length; j++) {
          var emailformat = window.regularExpressions.email.test(
            this.emailInvitationArr[j].toString().toLowerCase()
          );

          if (!emailformat) {
            this.$toasted.show("Please enter valid email!", {
              icon: "times-circle",
              className: "error-class",
            });
            return;
          }
        }
      }

      if (typeof this.value !== 'undefined' && this.value.length === 0) {

          this.$toasted.show("Please select at least one permit!", {
            icon: "times-circle",
            className: "error-class",
          });
          return;
      }

    /*   if (this.all_property == false && this.choosenPropertyIdArr.length == 0) {
        this.$toasted.show("Please select at least one property!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }

      if (
        (this.choicesProperty > this.choosenPropertyIdArr.length &&
          this.all_property == false) ||
        (this.choicesProperty > Object.keys(this.propertyListsMulti).length &&
          this.all_property == true)
      ) {
        this.$toasted.show(
          "Please select a valid number of properties, choosen property number can not more than the total valid property count!",
          {
            icon: "times-circle",
            className: "error-class",
          }
        );
        return;
      }

      if (this.all_property == true) {
        this.choosenPropertyIdArr = [];
      } */

      if (this.invitationStartDate == null || this.invitationStartDate == "") {
        this.$toasted.show("Please provide a valid Invitation start date!", {
          icon: "times-circle",
          className: "error-class",
        });
        return;
      }


      this.value.forEach((item, index)=>{
          this.choosenPropertyIdArr.push(item.property_id);  
          this.selected_permit_ids.push(item.id);          
      });

      this.choosenPropertyIdArr = [...new Set(this.choosenPropertyIdArr)];
      // console.log("uniqueu>>>>"+this.choosenPropertyIdArr);

      this.formData = new FormData();
      for (let i = 0; i < this.choosenPropertyIdArr.length; i++) {
        this.formData.append(
          "property_ids[" + i + "]",
          this.choosenPropertyIdArr[i]
        );
      }

      for (let i = 0; i < this.selected_permit_ids.length; i++) {
        this.formData.append(
          "permit_list[" + i + "]",
          this.selected_permit_ids[i]
        );
      }


      this.formData.append(
        "available_selections",
        this.choicesProperty != "" ? this.choicesProperty : ''
      );
      this.formData.append("email", this.emailInvitation);
      this.formData.append("invitation_name", this.groupName);
     /*  this.formData.append("property_all", this.all_property == true ? 1 : 0); */
      this.formData.append(
        "expiration_date",
        this.invitationExpirationDate
          ? this.$moment(this.invitationExpirationDate)
              .utc()
              .format("YYYY-MM-DD HH:mm:ss")
          : null
      );
      this.formData.append(
        "start_date",
        this.$moment(this.invitationStartDate)
          .utc()
          .format("YYYY-MM-DD HH:mm:ss")
      );
      this.formData.append("csv", this.csv_file);

      this.button.disabled = true;
      this.button.loading = true;

      this.axios
        .post(window.hostname + "api/auth/invitation/save", this.formData)
        .then((res) => {
          if (res.data.status) {
            this.button.disabled = false;
            this.button.loading = false;
            this.button.success = true;
            this.$toasted.show(res.data.message, {
              icon: "check-circle",
              className: "success-class",
            });
            this.$emit("update_invitation_list", true);
            //this.$modal.close("permit-ivitations-list");
            this.resetData();
            this.closeModal();
          } else {
            this.button.disabled = false;
            this.button.loading = false;
            this.$toasted.show(res.data.message, {
              icon: "times-circle",
              className: "error-class",
            });
          }
        })
        .catch((err) => {
          this.button.disabled = false;
          this.button.loading = false;
          this.button.success = false;
          this.$toasted.show(err.response.data.message, {
            icon: "times-circle",
            className: "error-class",
          });
        });
    }
  },
};
</script>

<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.9) !important;
}

.monthly-filter-select {
  width: 100%;
}

/* style the background and the text color of the input ... */
.vue-tags-input {
  border-radius: 16px !important;
  background: transparent !important;
  font-size: 12px !important;
  padding: 0 0.6rem !important;
  border: 1px solid hsla(0, 0%, 100%, 0.25) !important;
  max-width: 100% !important;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  color: hsla(0, 0%, 100%, 0.5);
}
.vue-tags-input.ti-focus {
  border-color: #f5a621 !important;
}

.vue-tags-input .ti-new-tag-input {
  background: transparent !important;
  color: #b7c4c9;
}

.ti-input {
  border: 0 !important;
  padding: 4px 10px;
  transition: border-bottom 200ms ease;
}

/* we cange the border color if the user focuses the input */
.vue-tags-input.ti-focus .ti-input {
  border: 1px solid #ebde6e;
}

/* some stylings for the autocomplete layer */
.vue-tags-input .ti-autocomplete {
  background: #191919 !important;
  border: 0 !important;
  border-top: none !important;
  border-radius: 10px !important;
  width: 148px !important;
  top: 35px !important;
  padding-top: 10px !important;
}

/* the selected item in the autocomplete layer, should be highlighted */
.vue-tags-input .ti-item {
  color: #fff;
}
.vue-tags-input .ti-item.ti-selected-item {
  background-color: transparent;
}

/* style the placeholders color across all browser */
.vue-tags-input ::-webkit-input-placeholder {
  color: #a4b1b6;
}

.vue-tags-input ::-moz-placeholder {
  color: #a4b1b6;
}

.vue-tags-input :-ms-input-placeholder {
  color: #a4b1b6;
}

.vue-tags-input :-moz-placeholder {
  color: #a4b1b6;
}

/* default styles for all the tags */
.vue-tags-input .ti-tag {
  position: relative !important;
  background: transparent !important;
  color: #fff !important;
  align-items: center !important;
}

/* the styles if a tag is invalid */
.vue-tags-input .ti-tag.ti-invalid {
  background-color: #e88a74;
}

/* if the user input is invalid, the input color should be red */
.vue-tags-input .ti-new-tag-input.ti-invalid {
  color: #e88a74;
}

/* if a tag or the user input is a duplicate, it should be crossed out */
.vue-tags-input .ti-duplicate span,
.vue-tags-input .ti-new-tag-input.ti-duplicate {
  text-decoration: line-through;
}

/* if the user presses backspace, the complete tag should be crossed out, to mark it for deletion */
.vue-tags-input .ti-tag:after {
  transition: transform 0.2s;
  position: absolute;
  content: "";
  height: 2px;
  width: 108%;
  left: -4%;
  top: calc(50% - 1px);
  background-color: #000;
  transform: scaleX(0);
}

.vue-tags-input .ti-deletion-mark:after {
  transform: scaleX(1);
}
.ti-tag .ti-actions {
  background-color: rgba(255, 255, 255, 0.2) !important;
  font-size: 8px !important;
  justify-content: center !important;
  width: 13px !important;
  height: 13px !important;
  border-radius: 100% !important;
  color: rgba(255, 255, 255, 0.25) !important;
}
.date-range-time-class-audit .date__range__input .field.is-dark .field-input {
  width: 150px;
  padding: 0 10px;
}
.date-range-time-class-audit .time-picker::after,
.date-range-time-class-audit .time-picker::before {
  border-top: 0;
  border-bottom: 0;
}

@media (max-width: 460px) {
  .date-range-time-class-audit {
    flex-direction: column;
  }
  .date-range-time-class-audit .separator {
    display: none;
  }
  .date-range-time-class-audit .date__range__input {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}
</style>
